import BackgroundImg from 'assets/images/background-main.png'
import styled from 'styled-components'

export const BackgroundMain = () => {
  return <Img className="bg" src={BackgroundImg} alt="Background" />
}

const Img = styled.img`
  position: fixed;
  max-width: 100%;
  max-height: 100%;
  height: 100%;
  width: 100%;
  inset: 0 0 0 0;
  z-index: -1;
`
